import React, { lazy } from 'react';
interface HeroSectionProps {
  handlePurchase: () => void;
}
export function HeroSection({
  handlePurchase
}: HeroSectionProps) {
  return <header className="px-4 sm:px-[5%] py-12 sm:py-20 flex justify-center items-center min-h-[auto] sm:min-h-[70vh] relative overflow-hidden [contain:content]" role="banner" data-id="element-144">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[50px] items-center w-full max-w-[1200px] relative z-10" data-id="element-145">
        {/* Mockup Visual */}
        <div className="relative flex flex-col items-center order-2 lg:order-1" data-id="element-146">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.18)_0%,transparent_70%)] scale-150 z-0 top-[-10%]" aria-hidden="true" data-id="element-147" />

          {/* Mobile CTA above image */}
          <button onClick={handlePurchase} className="lg:hidden mb-8 bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[320px] active:scale-95 relative z-10" data-id="element-148">
            DESCARGAR $14
          </button>
          <p className="lg:hidden text-[10px] text-gold font-bold mb-3 tracking-[2px] relative z-10" aria-hidden="true" data-id="element-149">
            ⚡ ACCESO DIGITAL • PAGO ÚNICO
          </p>
          <button onClick={() => {
          const el = document.getElementById('hoy-te-llevas');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setTimeout(() => {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }, 600);
          }
        }} className="lg:hidden text-gold text-[11px] font-bold uppercase tracking-[2px] underline underline-offset-4 decoration-gold/40 mb-6 relative z-10 bg-transparent border-none cursor-pointer" data-id="element-150">
            VER TODO LO QUE INCLUYE →
          </button>

          {/* CSS animation instead of framer-motion - removes ~40kb from critical path */}
          <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450" srcSet="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280 280w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=350 350w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450 450w" sizes="(max-width: 640px) 280px, (max-width: 1024px) 350px, 450px" alt="Manual Maestro 888" width={450} height={580} className="relative z-10 w-full max-w-[280px] sm:max-w-[350px] lg:max-w-[450px] rounded-xl shadow-[0_40px_80px_rgba(0,0,0,0.9)] aspect-[3/4] animate-float" loading="eager" decoding="async" fetchPriority="high" data-id="element-151" />
        </div>

        {/* Texto de Ventas Hero - CSS fade-in instead of framer-motion */}
        <div className="text-center lg:text-left order-1 lg:order-2 animate-fadeInUp" data-id="element-152">
          <span className="inline-block bg-gold/10 text-gold px-4 py-1.5 rounded-full text-[10px] sm:text-xs font-extrabold tracking-wider mb-4 sm:mb-6" data-id="element-153">
            OFERTA DE ACCESO INMEDIATO
          </span>

          <h1 className="font-serif text-[32px] sm:text-[40px] lg:text-[56px] leading-[1.1] font-black mb-4 sm:mb-6" data-id="element-154">
            PROGRAMACIÓN <br data-id="element-155" />
            <span className="text-gold" data-id="element-156">NEURO-CUÁNTICA</span>
          </h1>

          <p className="text-base sm:text-lg opacity-90 leading-[1.6] mb-8 sm:mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-157">
            Sintoniza tu sistema nervioso con la frecuencia de la abundancia y
            elimina bloqueos de escasez en 15 minutos.
          </p>

          <button onClick={handlePurchase} className="hidden lg:inline-block bg-gold text-dark border-none py-5 px-8 text-lg font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[400px] hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-158">
            <span data-id="element-159">DESCARGAR $14</span>
          </button>

          <p className="hidden lg:block text-xs text-gold font-bold mt-5 tracking-[2px]" aria-hidden="true" data-id="element-160">
            ⚡ ACCESO DIGITAL • PAGO ÚNICO
          </p>

          <button onClick={e => {
          const el = document.getElementById('hoy-te-llevas');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            // Re-scroll after lazy content loads
            setTimeout(() => {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }, 600);
          }
        }} className="hidden lg:inline-block mt-4 border border-gold text-gold text-[11px] font-extrabold px-6 py-2.5 rounded hover:bg-gold hover:text-dark transition-all uppercase tracking-wide cursor-pointer bg-transparent" data-id="element-161">
            VER TODO LO QUE INCLUYE →
          </button>
        </div>
      </div>
    </header>;
}